import { createAsyncThunk } from "@reduxjs/toolkit";

import { CachePolicy } from "api/types";
import { JANZU_URL } from "config/config";

export const getNotes = createAsyncThunk("notes/getNotes", async (detectorId: string) => {
  const response = await fetch(`${JANZU_URL}reef-api/notes?detector_id=${detectorId}`, {
    cache: CachePolicy.NO_CACHE,
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
  if (response.ok) {
    const data = await response.json();
    return data;
  }
  throw new Error("Failed to fetch notes");
});
